var _circle, _rect, _path, _rect2, _rect3, _path2, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E3F3EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22,
    width: 26,
    height: 18,
    rx: 3,
    fill: "#12B5A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 26h26",
    stroke: "#0B1739",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 7,
    height: 5,
    rx: 1,
    fill: "#fff",
    opacity: 0.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 7,
    height: 5,
    rx: 1,
    fill: "#0B1739",
    opacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5h16l2.5 3.5H17.5L20 18.5Z",
    fill: "#0B1739"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 38.5,
    r: 2.2,
    fill: "#0B1739"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 38.5,
    r: 2.2,
    fill: "#0B1739"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 38.5h7.6",
    stroke: "#0B1739",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatServices);
export default __webpack_public_path__ + "static/media/cat-services.048a62b86c4a5912084d40adced08b71.svg";
export { ForwardRef as ReactComponent };